import type { MyBetsState } from '../../types/myBets';

const betsLoadedUnsuccessfully = (state: MyBetsState): MyBetsState => ({
  ...state,
  isFetching: false,
  isErroneous: true
});

export default betsLoadedUnsuccessfully;
